(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireab88"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireab88"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7meeL", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf; }, function (v) { return $55b5a1b0c0eb630f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03; }, function (v) { return $55b5a1b0c0eb630f$export$f7ad0328861e2f03 = v; });
var $55b5a1b0c0eb630f$export$6503ec6e8aabbaf;
var $55b5a1b0c0eb630f$export$f7ad0328861e2f03;
"use strict";
var $55b5a1b0c0eb630f$var$mapping = new Map();
function $55b5a1b0c0eb630f$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$55b5a1b0c0eb630f$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $55b5a1b0c0eb630f$var$resolve(id) {
    var resolved = $55b5a1b0c0eb630f$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$55b5a1b0c0eb630f$export$6503ec6e8aabbaf = $55b5a1b0c0eb630f$var$register;
$55b5a1b0c0eb630f$export$f7ad0328861e2f03 = $55b5a1b0c0eb630f$var$resolve;

});

parcelRegister("c6lZy", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8cf71ab048827416$export$bdfd709ae4826697; }, function (v) { return $8cf71ab048827416$export$bdfd709ae4826697 = v; });
var $8cf71ab048827416$export$bdfd709ae4826697;
var $8cf71ab048827416$export$c9e73fbda7da57b6;
var $8cf71ab048827416$export$5a759dc7a1cfb72a;
"use strict";
var $8cf71ab048827416$var$bundleURL = {};
function $8cf71ab048827416$var$getBundleURLCached(id) {
    var value = $8cf71ab048827416$var$bundleURL[id];
    if (!value) {
        value = $8cf71ab048827416$var$getBundleURL();
        $8cf71ab048827416$var$bundleURL[id] = value;
    }
    return value;
}
function $8cf71ab048827416$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8cf71ab048827416$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $8cf71ab048827416$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8cf71ab048827416$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$8cf71ab048827416$export$bdfd709ae4826697 = $8cf71ab048827416$var$getBundleURLCached;
$8cf71ab048827416$export$c9e73fbda7da57b6 = $8cf71ab048827416$var$getBaseURL;
$8cf71ab048827416$export$5a759dc7a1cfb72a = $8cf71ab048827416$var$getOrigin;

});

var $eab567b66f6359db$exports = {};


(parcelRequire("7meeL")).register((parcelRequire("c6lZy")).getBundleURL("kbjbz"), JSON.parse('["kbjbz","index.a25f9351.js","6DhUL","FEAST_FLEET.2fbdbd07.svg","k8jGY","icons8-veg-32.1b7d3419.png","bOATe","icons8-non-veg-32.14536350.png","5ykGR","Grocery.0a09e808.js","k5wDQ","About.b47d958f.js"]'));

})();
//# sourceMappingURL=index.runtime.7d5f0b65.js.map
